import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISpinnerState } from './models/spinner-state.interface';
import { DictionaryType } from './models/dictionary-type.model';
import { ISpinnerStoreService } from './spinner-store.service.interface';
import { SpinnerState } from './models/spinner-state.model';

@Injectable({
  providedIn: 'root'
})
export class SpinnerStoreService implements ISpinnerStoreService {
  private readonly store = new BehaviorSubject<ISpinnerState>(new SpinnerState());

  private get currentState(): ISpinnerState {
    return this.store.getValue();
  }

  private readonly defaultSpinnerText = 'Even geduld aub...';

  /* Shows the spinner on the view */
  showSpinner(key: string, spinnerText: string): void {
    const messagesShow = new DictionaryType<string>();
    messagesShow.copy(this.currentState.messages);
    messagesShow.set(key, spinnerText);

    this.store.next({
      shown: messagesShow.count() > 0,
      messages: messagesShow
    });
  }

  /*
  * Hides the spinner message with key
  */
  hideSpinner(key: string): void {
    const messages = new DictionaryType<string>();
    messages.copy(this.currentState.messages);
    messages.remove(key);

    this.store.next({
      shown: messages.count() > 0,
      messages
    });
  }

  /*
  * Shows default spinner with Even geduld aub. text
  * returns key of spinner message
  */
  showDefaultSpinner(): string {
    const key = this.getRandomString(4);
    this.showSpinner(key, this.defaultSpinnerText);
    return key;
  }

  /*
  * Gets the spinner state from the store
  */
  getSpinnerState(): Observable<ISpinnerState> {
    return this.store.asObservable();
  }

  resetStore(): void {
    this.store.next(new SpinnerState());
  }

  /* Gets random string of variable length */
  private getRandomString(length: number): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }
}
